var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tactics main"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ornament"}),_c('div',{staticClass:"matter"}),_c('div',{staticClass:"elliptical"})])])
}]

export { render, staticRenderFns }